import { render } from "./question1.vue?vue&type=template&id=2dd51e9f&scoped=true"
import script from "./question1.vue?vue&type=script&lang=js"
export * from "./question1.vue?vue&type=script&lang=js"

import "./question1.vue?vue&type=style&index=0&id=2dd51e9f&scoped=true&lang=css"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd51e9f"]])

export default __exports__